/* eslint-disable eqeqeq */
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { Set_Modal_Checkbox } from "../SliceSalesInvoice.jsx";
import {
  DBKernUId,
  fKeyTabInput,
  userBasedHideField,
} from "../../../Utility/Utilitys.jsx";
// import { userBasedHideField } from "./../../../Configs/index";

import GCToggleTableSearch from "../../../Component/Common/ReuseableComponent/GCToggleTableSearch.jsx";

import {
  CmpSelectField,
  CmpSelectArrField,
  CmpInputFieldGroup,
  CmpInputField,
  CmpCheckboxField,
  CmpTypographyField,
  CmpButtonKWithIcon,
} from "../../../Component/Common/ToolBox/ToolBox.js";
import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch.jsx";
import Grid from "@mui/material/Grid";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky.jsx";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  CmpSelectArrFieldV1,
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1.js";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1.jsx";
import { Button, Tooltip, Typography, useMediaQuery } from "@mui/material";
import AutoGraphRoundedIcon from "@mui/icons-material/AutoGraphRounded";
import VisibilityIcon from "@mui/icons-material/Visibility";
export default function GCContent({
  vMediaQuery,
  fLocationwiseStock,
  fGrossAmt,
  bufferObj,
  fonClickInputFocus,
  fonClickInputBlur,
  // fOnChangeSelectUnit,
  fonChangeCheckBoxFoc,
  taxDept1,
  taxDept2,
  ItemUnit,
  ItemLocation,
  fonChangeInputQty,
  fonChangeInputItemName,
  fonChangeInputUnit,
  fonChangeB_Location,
  fonChangeInputUnitRateFC,
  fUnitRateFCSave_onKeyUp,
  fonChangeInputLDisc,
  fonChangeInputLDiscAmt,
  fonChangeInputExcise,
  //incentive
  fonChangeInputOtherAmtSc,
  fonChangeInputSupervisorAmtSc,
  fOnChangeSelectIncGroup,
  fOnChangeSelectSupervisorSlab,
  fOnChangeSelectOtherSlab,
  SupervisorSlabs,
  OtherSlabs,
  IncentiveGroups,
  //incentive
  xNarrArr,
  sErrorMsgDetail,
  vRdxWmsHead,
  xcolumnsDropdownSearch,
  xrowDropdownSearch,
  xOnCellKeyDown,
  xOnRowClick,
  xToggleDropdown,
  xhandleClick,
  xMediaQuery,
  fFocusShowSalesHistoryGrid,
  xinputRef,
  xData,
  xOnChange,
  xDropdownObj,
  xOnKeyUp,

  //narration
  fonChangeInputNarration,
  fNarrationKeyEnter,
  xNarrationToggleDropdown,
  xrowDropdownNarrationSearch,
  xcolumnsDropdownNarrationSearch,
  xOnCellKeyNarrationDown,
  xOnRowNarrationClick,

  //QuotationName
  xRefDocfonChangeInputName,
  xRefDochandleClick,
  xRefDocRowDropdownSearch,
  xRefDocColumnsDropdownSearch,
  xRefDocOnCellKeyDown,
  xRefDocOnRowClick,
  xRefDocToggleDropdown,
  xRefDocData,
  xRefDocOnChange,
  xRefDocDropdownObj,
  xRefDocOnKeyUp,
  xRefDocfOpenContentSearchModalKey,
  sTransItemStockObj,
  xTransItemStockShow,
  sWarranty,
  fonChangeInputWarranty,
}) {
  const vMediaQuery1600 = useMediaQuery("(max-width:1580)");
  const dispatch = useDispatch();
  console.log("bufferObj", bufferObj);
  const vRdxCheckbox = useSelector(
    (state) => state.SliceSalesInvoice.value.WmsInvoiceCheckbox
  );
  const vModelCheckboxArr = userBasedHideField()
    ? [
        { name: "SalesOrder", rdxName: vRdxCheckbox.SalesOrder },
        { name: "UnitRateLC", rdxName: vRdxCheckbox.UnitRateLC },
        { name: "LDisc", rdxName: vRdxCheckbox.LDisc },
        { name: "TDisc", rdxName: vRdxCheckbox.TDisc },
        { name: "Foc", rdxName: vRdxCheckbox.Foc },
        { name: "Excise", rdxName: vRdxCheckbox.Excise },
        { name: "TaxableAmount", rdxName: vRdxCheckbox.TaxableAmount },

        { name: "Narration", rdxName: vRdxCheckbox.Narration },
        { name: "Incentive", rdxName: vRdxCheckbox.Incentive },
        { name: "ItemCode", rdxName: vRdxCheckbox.ItemCode },
        { name: "PackQty", rdxName: vRdxCheckbox.PackQty },
        { name: "Warranty", rdxName: vRdxCheckbox.Warranty },
      ]
    : [
        { name: "SalesOrder", rdxName: vRdxCheckbox.SalesOrder },
        { name: "UnitRateLC", rdxName: vRdxCheckbox.UnitRateLC },
        { name: "LDisc", rdxName: vRdxCheckbox.LDisc },
        { name: "TDisc", rdxName: vRdxCheckbox.TDisc },
        { name: "Foc", rdxName: vRdxCheckbox.Foc },
        { name: "Excise", rdxName: vRdxCheckbox.Excise },
        { name: "TaxableAmount", rdxName: vRdxCheckbox.TaxableAmount },

        { name: "Narration", rdxName: vRdxCheckbox.Narration },
        { name: "ItemCode", rdxName: vRdxCheckbox.ItemCode },
        { name: "PackQty", rdxName: vRdxCheckbox.PackQty },
        { name: "Warranty", rdxName: vRdxCheckbox.Warranty },
      ];
  const [sIsChecked, setIsChecked] = useState(false); //ALL CHECKED
  const [sWmsInnCheckbox, setWmsInnCheckbox] = useState(vRdxCheckbox);

  const [sOpenContentModal, setOpenContentModal] = useState(false);
  const [sOpenModalName, setOpenModalName] = useState(""); // MODAL OPEN

  const fModalContentOpen = (e, ModalName) => {
    setOpenModalName(ModalName);
    setOpenContentModal(true);
  };

  const fModalContentClose = () => {
    setOpenContentModal(false);
  };

  const fIsAllChecked = (e) => {
    const iSCheck = e.target.checked;
    setIsChecked(iSCheck);
    const updatedObj = Object.keys(vRdxCheckbox).reduce((acc, key) => {
      acc[key] = iSCheck;
      return acc;
    }, {});

    // Update the state with the new object
    setWmsInnCheckbox(updatedObj);
  };

  const fSetCheckBox = (e) => {
    const nameValue = e.target.name;
    const iSCheck = e.target.checked;
    setWmsInnCheckbox((obj) => ({ ...obj, [nameValue]: iSCheck }));
  };

  useEffect(() => {
    dispatch(Set_Modal_Checkbox(sWmsInnCheckbox));
    const vIsAllTrue = Object.values(sWmsInnCheckbox).every(
      (value) => value === true
    );
    setIsChecked(vIsAllTrue);
  }, [sWmsInnCheckbox, dispatch]);

  return (
    <form
      className="Wms-sales-invoice-Content "
      id="WmssalesinvoiceContentID"
      autoComplete="off"
    >
      <Grid
        container
        spacing={0.9}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          container
          textAlign={"end"}
          justifyContent={"end"}
        >
          {/* {!vMediaQuery &&  <Grid
            item
            xs={12}
            sm={3}
            md={3}
             className="hand-pointer"
           >
 
            <CmpTypographyField
                xcomponent={"span"}
                xText={"Locationwise Stock"}
                xtextDecoration="underline"
                xonClick={fLocationwiseStock}
              />
          </Grid>} */}
          <Grid item xs={9} sm={6} md={3}>
            <Typography
              className="typograpgy-font txt-overflow-ellipse"
              sx={{
                fontSize: { md: "1vw", lg: "0.7vw" },
              }}
            >
              {vRdxWmsHead.A_DocStat !== "ENTER" && (
                <>
                  {"Stock=" + sTransItemStockObj.RPStock + " "}
                  {Number(sTransItemStockObj.MSP) > 0 &&
                    "MSP=" + sTransItemStockObj.MSP + " "}
                  {xTransItemStockShow && (
                    <>
                      {"CostPr=" + sTransItemStockObj.CostPr + " "}
                      {"LPRate=" + sTransItemStockObj.LPRate}
                    </>
                  )}
                </>
              )}
            </Typography>
          </Grid>
          {!vMediaQuery && (
            <Grid item xs={3} sm={3} md={3}>
              <MoreHorizOutlinedIcon
                onClick={(e) => { 
                  fModalContentOpen(e, "checkboxModal");
                }}
                className="form-label gnr-title-txt"
              />
            </Grid>
          )}
        </Grid>
        {/* { !xMediaQuery && <Grid item xs={3} sm={2} md={0.4} lg={1} className="lastkeyDetect">
           
            <CmpTextFieldV1
            xLabelText="S.No"
            xValue={bufferObj.B_Srno}
            xType={"text"} // text/number/password
            xName={"B_Srno"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_Srno === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_Srno}
          
          />
        </Grid>} */}

        <Grid
          item
          xs={6}
          sm={2}
          md={2}
          lg={0.9}
          className={
            vRdxCheckbox.SalesOrder ? "lastkeyDetect " : "hide-content"
          }
        >
          <CmpTextFieldV1
            xLabelText="Sales Order"
            xValue={bufferObj.B_RefDocTyp}
            xType={"text"} // text/number/password
            xName={""}
            xReadOnly={true}
            xOnChange={""}
            xError={false}
            xErrorMessage={""}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={6}
          sm={2}
          md={2}
          lg={1}
          className={
            vRdxCheckbox.SalesOrder ? "lastkeyDetect " : "hide-content"
          }
        >
          <CmpTextFieldV1
            xLabelText="Sales Order No"
            xValue={bufferObj.B_RefDocNo}
            xType={"text"} // text/number/password
            xName={""}
            xReadOnly={true}
            xOnChange={""}
            xError={false}
            xErrorMessage={""}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={xRefDocToggleDropdown ? 5 : 3}
          // lg={3}
          className={
            vRdxCheckbox.SalesOrder ? "lastkeyDetect " : "hide-content"
          }
        >
          <GCToggleSearchV1
            xLabelText="Sales Order Name"
            xtabIndex={"101"}
            xName={"B_RefDocName"}
            xType={"text"}
            xValue={bufferObj?.B_RefDocName}
            xReadOnly={false}
            xOnChange={xRefDocfonChangeInputName}
            xOnKeyUp={(e) => {
              xRefDocfOpenContentSearchModalKey(e, "itemSearch");
            }}
            xError={sErrorMsgDetail.B_RefDocName === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_RefDocName}
            xMediaQuery={xMediaQuery}
            xonClickbtn={xRefDochandleClick}
            xrows={xRefDocRowDropdownSearch}
            xcolumns={xRefDocColumnsDropdownSearch} //head
            xRowCellClick={xRefDocOnCellKeyDown}
            xRowClick={xRefDocOnRowClick}
            xToggle={xRefDocToggleDropdown}
            xData={xRefDocData}
            xOnChangeDropdownInput={xRefDocOnChange}
            xDropdownObj={xRefDocDropdownObj}
            xOnKeyUpDropdownInput={xRefDocOnKeyUp}
          />
        </Grid>
        <Grid
          item
          xs={vRdxCheckbox.SalesOrder ? 12 : 12}
          sm={vRdxCheckbox.SalesOrder ? 12 : 12}
          md={1.5}
          className={vRdxCheckbox.ItemCode ? "lastkeyDetect " : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Item Code"
            xValue={bufferObj.B_Itmcd}
            xType={"text"} // text/number/password
            xName={"B_Itmcd"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_Itmcd === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_Itmcd}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={10}
          md={vMediaQuery1600 ? 7.5 : xToggleDropdown ? 5 : 3}
          // lg={3}
          className="lastkeyDetect dropDowntoggle"
        >
          <GCToggleSearchV1
            xLabelText="Item Name"
            xtabIndex={"101"}
            xName={"B_ItmName"}
            xType={"text"}
            xValue={bufferObj?.B_ItmName}
            xReadOnly={false}
            xOnChange={fonChangeInputItemName}
            xOnKeyUp={(e) => {
              xhandleClick(e, "itemSearch");
            }}
            xError={sErrorMsgDetail.B_ItmName === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_ItmName}
            xMediaQuery={xMediaQuery}
            xonClickbtn={xhandleClick}
            xrows={xrowDropdownSearch}
            xcolumns={xcolumnsDropdownSearch} //head
            xRowCellClick={xOnCellKeyDown}
            xRowClick={xOnRowClick}
            xToggle={xToggleDropdown}
            xData={xData}
            xOnChangeDropdownInput={xOnChange}
            xDropdownObj={xDropdownObj}
            xOnKeyUpDropdownInput={xOnKeyUp}
          />
        </Grid>

        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Qty"
            xtabIndex={"102"}
            xValue={bufferObj.B_Qty}
            xType={"number"} // text/number/password
            xName={"B_Qty"}
            xReadOnly={false}
            xOnChange={fonChangeInputQty}
            xError={sErrorMsgDetail.B_Qty === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_Qty}
            xOnKeyUp={(e) => {
              fKeyTabInput(e, "B_URateFc");
            }}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} lg={1} className="lastkeyDetect">
          <CmpSelectFieldV1
            xtabIndex={"103"}
            xLabelText="Unit"
            xValue={bufferObj.B_Unit}
            xOnChange={(e) => {
              fonChangeInputUnit(e, ItemUnit);
            }}
            xName={"B_Unit"}
            xData={ItemUnit}
            xValueMember={""}
            xDispalyMember={""}
            xError={sErrorMsgDetail.B_Unit === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_Unit}
            xDisable={bufferObj.B_RefNo1 != ""}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
          />
        </Grid>
        {vRdxCheckbox.PackQty && (
          <Grid item xs={4} sm={1} md={1} className="lastkeyDetect">
            <CmpTextFieldV1
              xLabelText="PackQty"
              xSize="small"
              xtabIndex={"103"}
              xValue={bufferObj.B_PackQty}
              xType={"text"} // text/number/password
              xName={"B_PackQty"}
              xReadOnly={true}
              xOnChange={() => {}}
              xError={false}
              xErrorMessage={""}
            />
          </Grid>
        )}
        <Grid item xs={4} sm={2} md={1} lg={2} className="lastkeyDetect">
          <CmpSelectFieldV1
            xtabIndex={"103"}
            xLabelText="Location"
            xValue={bufferObj.B_Location}
            xOnChange={(e) => {
              fonChangeB_Location(e, ItemLocation);
            }}
            xName={"B_Location"}
            xData={ItemLocation}
            xValueMember={""}
            xDispalyMember={""}
            xError={sErrorMsgDetail.B_Location === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_Location}
            xDisable={true}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
          />
        </Grid>

        <Grid item xs={4} sm={2} md={1.2} lg={1.2} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Unit Rate FC"
            xtabIndex={"104"}
            xValue={bufferObj.B_URateFc}
            xType={"number"} // text/number/password
            xName={"B_URateFc"}
            xReadOnly={false}
            xOnChange={fonChangeInputUnitRateFC}
            xError={sErrorMsgDetail.B_URateFc === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_URateFc}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
            xOnKeyUp={(e) => fUnitRateFCSave_onKeyUp(e)}
          />
        </Grid>
        {vRdxCheckbox.UnitRateLC && (
          <Grid item xs={4} sm={2} md={1.2} lg={1.2} className="lastkeyDetect">
            <CmpTextFieldV1
              xLabelText="Unit Rate LC"
              xtabIndex={"104"}
              xValue={bufferObj.B_URateLc}
              xType={"number"} // text/number/password
              xName={"B_URateLc"}
              xReadOnly={true}
              xOnChange={() => {}}
              xError={sErrorMsgDetail.B_URateLc === "" ? false : true}
              xErrorMessage={sErrorMsgDetail.B_URateLc}
              xonFocus={(e) => {
                // fFocusShowSalesHistoryGrid(e);
                // fonClickInputFocus(e);
              }}
              xonBlur={(e) => {
                // fonClickInputBlur(e);
              }}
              // xOnKeyUp={(e) => fUnitRateFCSave_onKeyUp(e)}
            />
          </Grid>
        )}

        <Grid item xs={4} sm={2} md={0.7} lg={0.7} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Gross Amt"
            xtabIndex={"105"}
            xValue={bufferObj.B_GrossAmt}
            xType={"text"} // text/number/password
            xName={"B_GrossAmt"}
            xReadOnly={false}
            xOnChange={fGrossAmt}
            xError={sErrorMsgDetail.B_GrossAmt === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_GrossAmt}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid
          item
          xs={4}
          sm={2}
          md={0.7}
          lg={0.7}
          className={vRdxCheckbox.TDisc ? "lastkeyDetect " : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="T.Disc %"
            xValue={bufferObj.B_TDiscPerc}
            xType={"text"} // text/number/password
            xName={"B_TDiscPerc"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_TDiscPerc === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_TDiscPerc}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={0.7}
          lg={0.7}
          className={vRdxCheckbox.TDisc ? "lastkeyDetect " : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="T.Disc Amt"
            xValue={bufferObj.B_TDiscAmt}
            xType={"text"} // text/number/password
            xName={"B_TDiscAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_TDiscAmt === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_TDiscAmt}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={0.7}
          lg={0.7}
          className={vRdxCheckbox.LDisc ? "lastkeyDetect " : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Disc %"
            xtabIndex={"106"}
            xValue={bufferObj.B_LDiscPerc}
            xType={"number"} // text/number/password
            xName={"B_LDiscPerc"}
            xReadOnly={false}
            xOnChange={fonChangeInputLDisc}
            xError={sErrorMsgDetail.B_LDiscPerc === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_LDiscPerc}
            xonFocus={(e) => {
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
            xOnKeyUp={(e) => {
              fKeyTabInput(e, "B_LDiscAmt");
            }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={0.7}
          lg={0.7}
          className={vRdxCheckbox.LDisc ? "lastkeyDetect " : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Disc Amt"
            xValue={bufferObj.B_LDiscAmt}
            xType={"text"} // text/number/password
            xName={"B_LDiscAmt"}
            xReadOnly={false}
            xOnChange={fonChangeInputLDiscAmt}
            xError={sErrorMsgDetail.B_LDiscAmt === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_LDiscAmt}
            xonFocus={(e) => {
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
            xOnKeyUp={(e) => {
              fKeyTabInput(e, "B_ExciseTaxAmt");
            }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={0.6}
          lg={0.6}
          className={
            vRdxCheckbox.Foc ? "lastkeyDetect text-center" : "hide-content"
          }
        >
          <CmpCheckboxField
            xtabIndex={"107"}
            xChecked={bufferObj?.B_FocFlag === "Y"}
            xOnChange={(e) => {
              fonChangeCheckBoxFoc(e);
            }}
            xDisabled={false}
            xName={"B_FocFlag"}
            xNameField={"FOC"}
            xError={sErrorMsgDetail.B_FocFlag === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_FocFlag}
          />
        </Grid>

        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Foc ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="FOC Amount"
            xValue={bufferObj.B_FocAmt}
            xType={"text"} // text/number/password
            xName={"B_FocAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_FocAmt === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_FocAmt}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={0.6}
          lg={0.6}
          className={vRdxCheckbox.Excise ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Excise"
            xtabIndex={"108"}
            xValue={bufferObj.B_ExciseTaxAmt}
            xType={"number"} // text/number/password
            xName={"B_ExciseTaxAmt"}
            xReadOnly={false}
            xOnChange={(e) => {
              fonChangeInputExcise(e);
            }}
            xError={sErrorMsgDetail.B_ExciseTaxAmt === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_ExciseTaxAmt}
            xonFocus={(e) => {
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
            xOnKeyUp={(e) => {
              fKeyTabInput(e, "Narration");
            }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={0.8}
          lg={0.8}
          className={vRdxCheckbox.Excise ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Net Excise"
            xValue={bufferObj.B_ExciseTaxNetAmt}
            xType={"number"} // text/number/password
            xName={"B_ExciseTaxNetAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_ExciseTaxNetAmt === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_ExciseTaxNetAmt}
            xonFocus={(e) => {
              fonClickInputFocus(e);
            }}
            xonBlur={(e) => {
              fonClickInputBlur(e);
            }}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={
            vRdxCheckbox.TaxableAmount ? "lastkeyDetect" : "hide-content"
          }
        >
          <CmpTextFieldV1
            xLabelText="TaxableAmt"
            xValue={bufferObj.B_NetAmt}
            xType={"number"} // text/number/password
            xName={"B_NetAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_NetAmt === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_NetAmt}
            // xOnKeyUp={xKey}
          />
        </Grid>

        {/* <Grid item xs={4} sm={2} md={1} lg={1} className={"lastkeyDetect"}>
          <CmpTextFieldV1
            xLabelText="Total"
            xValue={bufferObj.B_LandVal}
            xType={"number"} // text/number/password
            xName={"B_LandVal"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_LandVal === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_LandVal}
          // xOnKeyUp={xKey}
          />
        </Grid> */}

        <Grid
          item
          xs={8}
          sm={3}
          md={2}
          lg={2}
          className={
            vRdxCheckbox.Narration
              ? " lastkeyDetect dropDowntoggle"
              : "hide-content dropDowntoggle"
          }
        >
          <CmpTextFieldV1
            xLabelText="Narration"
            xValue={bufferObj.Narration}
            xType={"text"} // text/number/password
            xName={"Narration"}
            xReadOnly={false}
            xOnChange={(e) => {
              fonChangeInputNarration(e.target.value);
            }}
            xError={sErrorMsgDetail.Narration == "" ? false : true}
            xErrorMessage={sErrorMsgDetail.Narration}
            // xOnKeyUp={xKey}
          />
        </Grid>
        {DBKernUId("WARRANTY_ACTIVE") && vRdxCheckbox.Warranty && (
          <Grid item xs={4} sm={2} md={1} lg={1} className="lastkeyDetect">
            <CmpSelectFieldV1
              xtabIndex={"103"}
              xLabelText="Warranty"
              xValue={bufferObj.Warranty}
              xOnChange={(e) => {
                fonChangeInputWarranty(e, sWarranty);
              }}
              xName={"Warranty"}
              xData={sWarranty}
              xValueMember={""}
              xDispalyMember={""}
              xError={sErrorMsgDetail.Warranty === "" ? false : true}
              xErrorMessage={sErrorMsgDetail.Warranty}
              xDisable={false}
              xonFocus={(e) => {
                fFocusShowSalesHistoryGrid(e);
              }}
              xonBlur={(e) => {
                fonClickInputBlur(e);
              }}
            />
          </Grid>
        )}
        <Grid
          item
          xs={4}
          sm={2}
          md={2.2}
          lg={2.2}
          className={
            vRdxCheckbox.Incentive && userBasedHideField()
              ? "lastkeyDetect"
              : "hide-content"
          }
        >
          <CmpSelectFieldV1
            xtabIndex={"113"}
            xLabelText="IncentiveGroup"
            xValue={bufferObj.B_IncGroup}
            xOnChange={(e) => {
              fOnChangeSelectIncGroup(e, IncentiveGroups);
            }}
            xName={"B_IncGroup"}
            xData={IncentiveGroups}
            xValueMember={""}
            xDispalyMember={""}
            xError={sErrorMsgDetail.B_IncGroup === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_IncGroup}
            xDisable={false}
            // xOnKeyUp={""}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={
            vRdxCheckbox.Incentive && userBasedHideField()
              ? "lastkeyDetect"
              : "hide-content"
          }
        >
          <CmpTextFieldV1
            xLabelText="Supervisor%"
            xValue={bufferObj.B_SuprvPerc}
            xType={"text"} // text/number/password
            xName={"B_SuprvPerc"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_SuprvPerc === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_SuprvPerc}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={
            vRdxCheckbox.Incentive && userBasedHideField()
              ? "lastkeyDetect"
              : "hide-content"
          }
        >
          <CmpTextFieldV1
            xLabelText="Others%"
            xValue={bufferObj.B_OthersPerc}
            xType={"text"} // text/number/password
            xName={"B_OthersPerc"}
            xReadOnly={true}
            xOnChange={""}
            xError={sErrorMsgDetail.B_OthersPerc === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_OthersPerc}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={2}
          lg={2}
          className={
            vRdxCheckbox.Incentive && userBasedHideField()
              ? "lastkeyDetect"
              : "hide-content"
          }
        >
          <CmpSelectArrFieldV1
            xtabIndex={"114"}
            xLabelText="SupervisorSlab"
            xValue={bufferObj.B_SLANSuprv}
            xOnChange={(e) => {
              fOnChangeSelectSupervisorSlab(e, SupervisorSlabs);
            }}
            xName={"B_SLANSuprv"}
            xData={SupervisorSlabs}
            xValueMember={""}
            xDispalyMember={""}
            xError={sErrorMsgDetail.B_SLANSuprv === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_SLANSuprv}
            xDisable={false}
            // xOnKeyUp={""}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={
            vRdxCheckbox.Incentive && userBasedHideField()
              ? "lastkeyDetect"
              : "hide-content"
          }
        >
          <CmpTextFieldV1
            xLabelText="Amt/Sc"
            xValue={bufferObj.B_SlabAmtSuprv}
            xType={"text"} // text/number/password
            xName={"B_SlabAmtSuprv"}
            xReadOnly={bufferObj.B_SLANSuprv !== "SC"}
            xOnChange={fonChangeInputSupervisorAmtSc}
            xError={sErrorMsgDetail.B_SlabAmtSuprv === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_SlabAmtSuprv}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={2}
          lg={2}
          className={
            vRdxCheckbox.Incentive && userBasedHideField()
              ? "lastkeyDetect"
              : "hide-content"
          }
        >
          <CmpSelectArrFieldV1
            xtabIndex={"115"}
            xLabelText="OtherSlab"
            xValue={bufferObj.B_SLANOther}
            xOnChange={(e) => {
              fOnChangeSelectOtherSlab(e, OtherSlabs);
            }}
            xName={"B_SLANOther"}
            xData={OtherSlabs}
            xValueMember={""}
            xDispalyMember={""}
            xError={sErrorMsgDetail.B_SLANOther === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_SLANOther}
            xDisable={false}
            // xOnKeyUp={""}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={
            vRdxCheckbox.Incentive && userBasedHideField()
              ? "lastkeyDetect"
              : "hide-content"
          }
        >
          <CmpTextFieldV1
            xLabelText="Amt/Sc"
            xtabIndex={"117"}
            xValue={bufferObj.B_SlabAmtOther}
            xType={"number"} // text/number/password
            xName={"B_SlabAmtOther"}
            xReadOnly={bufferObj.B_SLANOther !== "SC"}
            xOnChange={fonChangeInputOtherAmtSc}
            xError={sErrorMsgDetail.B_SlabAmtOther === "" ? false : true}
            xErrorMessage={sErrorMsgDetail.B_SlabAmtOther}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={0.5}
          className="lastkeyDetect"
          display={"flex  "}
          alignItems={"center"}
          justifyContent={"space-around"}
        >
          <div>
            <Tooltip title="View Location-wise Stock" arrow>
              
               <CmpButtonKWithIcon
                            xOnClick={fLocationwiseStock}
                            xDisabled={false}
                            xIcon={<AutoGraphRoundedIcon fontSize={"small"} />}
                            xcolor="primary"
                          />
            </Tooltip>
          </div>

          <div>
            
            {vMediaQuery && (
               
               <CmpButtonKWithIcon
               xOnClick={(e) => { 
                fModalContentOpen(e, "checkboxModal");
              }}
               xDisabled={false}
               xIcon={<VisibilityIcon fontSize={"small"} />}
               xcolor="primary"
             />
            )}
          </div>
        </Grid>
        {/* {vMediaQuery &&   <Grid  item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          display={'flex  '}
          alignItems={'center'}
          >
          <MoreHorizOutlinedIcon
              onClick={(e) => { 
                
                fModalContentOpen(e, "checkboxModal");
              }}
              className="form-label gnr-title-txt"
            />
          </Grid>} */}
      </Grid>

      <Modal
        open={sOpenContentModal}
        onClose={fModalContentClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className={
            sOpenModalName == "checkboxModal"
              ? "model-content-checkbox"
              : "model-content-Item-Search"
          }
        >
          <div>
            {sOpenModalName == "checkboxModal" ? (
              <>
                <GCTitleSticky
                  title={"Detail list"}
                  onClose={fModalContentClose}
                />

                <div className="container-fluid">
                  <div className="wms-label">
                    <div className="checkbox-mb">
                      <label className="form-label typograpgy-font">
                        <input
                          className="form-check-input "
                          type="checkbox"
                          name="AllChecked"
                          checked={sIsChecked}
                          onChange={(e) => {
                            fIsAllChecked(e);
                          }}
                        />{" "}
                        All
                      </label>
                    </div>
                    <>
                      {vModelCheckboxArr?.map((obj, index) => (
                        <div
                          className="checkbox-mb"
                          key={"Wmscheckbox" + index}
                        >
                          <label className="form-label typograpgy-font">
                            <input
                              className="form-check-input "
                              type="checkbox"
                              name={obj.name}
                              checked={obj.rdxName}
                              onChange={(e) => {
                                fSetCheckBox(e);
                              }}
                            />{" "}
                            {obj.name}
                          </label>
                        </div>
                      ))}
                    </>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </Box>
      </Modal>
    </form>
  );
}
